import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SvgIconDirective } from './svg-icon.directive';

@NgModule({
  declarations: [SvgIconDirective],
  exports: [
    SvgIconDirective
  ],
  imports: [
    CommonModule
  ]
})
export class SvgIconModule {
}
